import React, { useEffect, useState, useRef, useCallback } from 'react'
import { baseUrl } from '../settings'
import { tweetArray, tweet } from '../Types/Tweets'
import FeedCard from './FeedCard'

import { v4 as uuidv4 } from 'uuid';

import InfiniteScroll from 'react-infinite-scroll-component';

type urlData = {
    url: string
}

const Feed = (props: urlData) => {

    const {url} = props

    const [pageNumber, setPageNumber] = useState(1) as [number, Function] 
    const [items, setItems] = useState([]) as [tweetArray, Function]
    const [load, setLoad] = useState(true)
    const [hasMore, setHasMore] = useState(true)


    useEffect(() => {

        if(pageNumber !== 1) {
            return
        }

        fetch(`${url}?page_number=${pageNumber}`)
        .then(response => {
            if(response.status === 204) {
                setLoad(true)
                setHasMore(false)
                return []
            }
            setPageNumber(pageNumber + 1)
            return response.json()
        })
        .then(newItems => {
            if(!props.from_liked) {
                let renderItems = newItems.map((item: tweet) => <FeedCard {...item} key={uuidv4()}></FeedCard>)
                setItems( (items: any) => [...items, ...renderItems])
                setLoad(false)
            }
            else {
                let renderData = newItems.map((data: any) => {
                    const transformedData = {} as any;
                    transformedData.tweeter = {...data.starred.tweeter}
                    transformedData.content = data.starred.content
                    transformedData.likes =  data.starred.likes
                    transformedData.posted_on = data.starred.posted_on
                    transformedData.is_liked = true
                    transformedData.id = data.starred.id
                    return transformedData
                })
                let renderItems = renderData.map((item: any) => <FeedCard {...item} key={uuidv4()}></FeedCard>)
                console.log(renderItems)
                setItems( (items: any) => [...items, ...renderItems])
                setLoad(false)
            }
        })
    }, [pageNumber])

    const fetchData = () => {
        fetch(`${url}?page_number=${pageNumber}`)
        .then(response => {
            if(response.status === 204) {
                setLoad(true)
                setHasMore(false)
                return []
            }
            setPageNumber(pageNumber + 1)
            return response.json()
        })
        .then(newItems => {
            if(!props.from_liked) {
                let renderItems = newItems.map((item: tweet) => <FeedCard {...item} key={uuidv4()}></FeedCard>)
                setItems( (items: any) => [...items, ...renderItems])
                setLoad(false)
            }
            else {
                let renderData = newItems.map((data) => console.log("HEHEHEHEH"))
            }
        })
    }
    
    return         <InfiniteScroll
        dataLength={items.length}
        next={fetchData}
        hasMore={hasMore}
        loader={<p>Loading..</p>}
        endMessage={
    <p style={{ textAlign: 'center' }}>
      <b>Yay! You have seen it all. End of Feed</b>
    </p>
  }
        >
            {items}
        </InfiniteScroll>
}

export default Feed
